import { Injector } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { environment } from '../../../environments/environment';
import { Logger } from './logger.service';
import { ActivatedRoute, Router } from '@angular/router';
/**
 * Settings for Log Interceptor
 */
// If set to false only specified routes are logged
var logAllRoutes = true;
var routesWhiteList = [];
var routesBlackList = [];
var redirectBlackList = [
    '/imprint', '/tos', '/privacy', '/copyright',
];
// Settings for successful requests
var requestDetails = {
    showLog: true,
    method: true,
    status: true,
    time: true,
    body: true,
};
// Settings for failed requests
var errorDetails = {
    showLog: true,
    method: true,
    status: true,
    time: true,
};
/**
 * Interceptor that adds the authentication header to request
 */
var LogInterceptor = (function () {
    /**
     * Constructor
     */
    function LogInterceptor(injector) {
        this.injector = injector;
    }
    /**
     * Intercepts the request and adds the authentication header
     * @param {HttpRequest<any>} req Request
     * @param {HttpHandler}      next HttpHandler
     * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
     */
    LogInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        var started = Date.now();
        this.router = this.injector.get(Router);
        this.route = this.injector.get(ActivatedRoute);
        return next.handle(req)
            .do(function (event) {
            if (event instanceof HttpResponse) {
                var elapsed = Date.now() - started;
                // Only log if not production build and logging of successful requests is activated
                if (!environment.production && requestDetails.showLog) {
                    // Removes the backend url prefix of request url
                    var shortendUrl = req.url.substr(environment.backendUrl.length, req.url.length);
                    // Log only if logging for all routes is activated or the current route is on the 'whitelist'
                    if ((logAllRoutes && routesBlackList.indexOf(shortendUrl) === -1) || routesWhiteList.indexOf(shortendUrl) !== -1) {
                        var output = '┌──── SUCCESSFUL REQUEST ─────\n';
                        output += '│ url:    ' + req.url + '\n';
                        if (requestDetails.method) {
                            output += '│ method: ' + req.method + '\n';
                        }
                        if (requestDetails.status) {
                            output += '│ status: ' + event.status + '\n';
                        }
                        if (requestDetails.time) {
                            output += '│ time:   ' + elapsed + 'ms\n';
                        }
                        var body = event.body.data || req.body || null; // Body is different if GET or POST method is used
                        if (requestDetails.body && body) {
                            output += '│ body:\n';
                            // Display all keys and values
                            for (var key in body) {
                                if (body.hasOwnProperty(key)) {
                                    output += '│   ' + key + ': ' + JSON.stringify(body[key]) + '\n';
                                }
                            }
                        }
                        output += '└─────────────────────────────';
                        Logger.log(output);
                    }
                }
            }
        }, function (err) {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    // Scip Redirect to Login-Page for specific URLs
                    if (redirectBlackList.indexOf(_this.router.url) === -1) {
                        _this.router.navigate(['login']).then(function () {
                            Logger.log('\n┌─────── LOGIN TIMEOUT ───────┐\n' +
                                '│ JWT is no longer valid!     │\n' +
                                '│ -> Navigated to Login       │\n' +
                                '└─────────────────────────────┘');
                        });
                    }
                    else {
                        Logger.log('\n┌─────── LOGIN TIMEOUT ───────┐\n' +
                            '│ JWT is no longer valid!     │\n' +
                            '└─────────────────────────────┘');
                    }
                }
                else if (err.status === 403 || err.status === 404 || err.status === 408) {
                    // Only log if not production build and logging of failed requests is activated
                    if (!environment.production && errorDetails.showLog) {
                        var elapsed = Date.now() - started;
                        var output = '\n┌────── FAILED REQUEST ───────\n';
                        output += '│ url:    ' + req.url + '\n';
                        if (errorDetails.method) {
                            output += '│ method: ' + req.method + '\n';
                        }
                        if (errorDetails.status) {
                            output += '│ status: ' + err.status + ' (' + err.statusText + ')' + '\n';
                        }
                        if (errorDetails.time) {
                            output += '│ time:   ' + elapsed + 'ms\n';
                        }
                        output += '└─────────────────────────────';
                        Logger.error(output);
                    }
                }
            }
        });
    };
    return LogInterceptor;
}());
export { LogInterceptor };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/log.interceptor.ts.pre-build-optimizer.js